import * as types from "./types";
import Routes from "../../api/routes"; // API endpoint routes
import { get, post, remove } from "../../api";

const { CREDIT_CARD_SAVE, CREDITE_CARD_DETAILS, DELETE_CREDIT_CARD_DETAILS } =
  Routes;

/*******************
@purpose :  send payment detail
@Parameter : {data}
@Author : INIC
******************/
export const addPaymentDetail = (data) => (dispatch) => {
  return post(`${CREDIT_CARD_SAVE}`, true, data).then((res) => {
    if (res) {
      return res;
    }
    return Promise.reject(res);
  });
};

/*******************
@purpose :  get card detail data
@Parameter : {}
@Author : INIC
******************/

export const getCrediteCardDetails =
  (loader = true) =>
  async (dispatch) => {
    try {
      let res = await get(CREDITE_CARD_DETAILS, true, loader);
      // dispatch({ type: types.SET_CREDITE_CARD_DETAIL, data: res?.data?.data });
      dispatch(setCardData(res?.data?.data));
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  };

/*******************
@purpose :  set card data in redux 
@Parameter : {data}
@Author : INIC
******************/
export const setCardData = (cardData) => {
  return {
    type: types.SET_CREDITE_CARD_DETAIL,
    data: cardData,
  };
};

/*******************
@purpose :  delete card detail data
@Parameter : {cardId}
@Author : INIC
******************/

export const deleteCrediteCardDetails =
  (cardId, reload = true) =>
  async (dispatch) => {
    try {
      let res = await remove(`${DELETE_CREDIT_CARD_DETAILS}/${cardId}`, true);
      if (res && reload) {
        dispatch(getCrediteCardDetails());
      }
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  };
